// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // API_BASE_URL: 'http://credentials-management-api-env-1.eba-j3e64kqa.us-east-2.elasticbeanstalk.com',
  // API_BASE_URL: 'http://localhost:3000',
  API_BASE_URL: 'https://creds-api-staging.staffy.com',
  PUSH_WOOSH_APP_ID: '',
  PUSH_WOOSH_PROJECT_ID: '',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
